import React from 'react'
import './ReviewLogsTable.css';
import { convertEpochMillisToDateTime } from '../../../utils/dateUtils'
import AlertLabel from '../../common/alertLabel/AlertLabel';
import ExpandableText from '../../common/expandableText/ExpandableText';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';

const ReviewLogsTable = ({ logs = [], onLogUpdate }) => {

    const getRowClass = (logMessage) => {
        if (logMessage.includes('APPROVED')) {
            return 'successRow'
        } else if (logMessage.includes('REJECTED')) {
            return 'errorRow'
        }
    }

    return (
        <div className="logs-container review-component-container full-width">
            <h2 className="logs-title">Reviewer Action Log</h2>
            {
                (logs.length > 0) ? (
                    <TableContainer
                        component={Paper}
                        className="logs-table-container"
                        sx={{
                            maxHeight: 275, // Fixed height for the table
                            overflowY: 'auto', // Enable vertical scrolling
                            overflowX: 'hidden', // Prevent horizontal overflow
                            boxShadow: 'none',
                            borderRadius: '8px'
                        }}
                    >
                        <Table
                            stickyHeader
                            sx={{
                                borderCollapse: 'collapse',
                            }}
                            className="logs-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="date-time-col">Date Time</TableCell>
                                    <TableCell className="reviewer-col">Reviewer</TableCell>
                                    <TableCell className="notes-col">Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {logs.map((log, index) => (
                                    <TableRow key={index} className={`"log-row" ${getRowClass(log.notes)}`}>
                                        <TableCell>{convertEpochMillisToDateTime(log.timestamp)}</TableCell>
                                        <TableCell>{log.reviewerName}</TableCell>
                                        <TableCell>
                                            <ExpandableText text={log.notes} maxLines={1} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>)
                    : (
                        <div className="error-label-container">
                            <AlertLabel message="No logs found" />
                        </div>)
            }
        </div>
    )
}

export default ReviewLogsTable